//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import XyTabbarItem from './TabbarItem.vue'
  import router from '../router'
  import XyTabbar from './Tabbar.vue'
  import Bus from './bus.js'
  export default{
    components: {
      XyTabbarItem,
      Bus
    },
    methods: {
      clickItem(index) {
        let children = this.$children
        for (let i = 0; i < children.length; i++) {
          children[i].selected = i === index
          if (children[i].selected) {
            window.localStorage.setItem('XYTabbarSelectIndex', i)
            switch (i) {
              case 0:
                this.$router.push({name: 'Operating'})
                break;
              case 1:
                this.$router.push({name: 'Cash'})
                break;
              case 2:
                this.$router.push({name: 'Gold'})
                break;
              default:
                break
            }
          }
        }
       
      }
    },
    mounted() {
      let selectIndex = window.localStorage.getItem('XYTabbarSelectIndex')
      if (!selectIndex) {
        selectIndex = 0
        window.localStorage.setItem('XYTabbarSelectIndex', selectIndex)
      }
      let children = this.$children[selectIndex]
      children.selected = true
      
      Bus.$on('msg', (e) => {
        console.log(66666)
　　　　　console.log('传来的数据是：${e}')
       })
    }

  }



// WEBPACK FOOTER //
// ./src/components/Tabbar.vue